export default "__VITE_ASSET__jIrXZrQ9__"